module.exports = __webpack_public_path__ + "static/media/blueStairsUp.fb70c504.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/blueStairsUp.svg
// module id = 455
// module chunks = 0